
//Représente les paramètres de rapprochement d’un complément comptable BT-30
export class AeFRapprocherComplementComptableBt30Parametres 
{
  //Création
  constructor () 
  {
    this.identifiantSession = "";
    this.identifiantFacture = "";
    this.numeroFacture = "";
    this.identifiantComplementComptable = "";
  }

  //Identifiant de la session
  public identifiantSession: string;

  //Identifiant de la facture
  public identifiantFacture: string;

  //Numéro de facture
  public numeroFacture: string;

  //Identifiant du complément comptable
  public identifiantComplementComptable: string;
}
